import { apiScoping } from '@/lib/api/scoping'

export type MaterializeUsersParams = {
  ids: string[]
}

export async function materializeUsers(params: MaterializeUsersParams): Promise<void> {
  await apiScoping.post('/api/v1/users/materialize', params)
}
